<template>
  <div class="leftContent">
    <!-- 324157 -->
    <el-menu
      :default-active="CurrentPath"
      router
      :collapse="collapse"
      class="el-menu-vertical-demo"
      :background-color="abckground == ''?'#242F42':abckground"
      text-color="#ffff"
      :active-text-color="abckground == '#409EFF'?'#90ee90':abckground == '#47a96c'?'#ff8c00':'#20a0ff'"
      :collapse-transition="false"
      @select="activeFun"
      unique-opened
    >
      <template v-for="item in moenu">
        <el-submenu :index="item.path" v-if="item.child != ''">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{lang_file != 'en-us' ?item.title:item.title_en}}</span>
          </template>
          <el-menu-item-group v-for="itemName in item.child" :key="itemName.id">
            <el-menu-item :index="itemName.path">{{lang_file != 'en-us'?itemName.title:itemName.title_en}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item :index="item.path" v-else>
          <i :class="item.icon"></i>
          <span slot="title">{{lang_file != 'en-us' ?item.title:item.title_en}}</span>
        </el-menu-item>
      </template>
    </el-menu>
    {{handState}}
  </div>
</template>
<script>
import { NavLeft } from "../../network/index";
import navMenu from "../../json/navMenu.json";
import bus from "@/components/common/bus";
import {mapState} from 'vuex'
export default {
  data() {
    return {
      collapse: false,
      moenu: [],
      loading: true,
      active: "",
      lang_file:sessionStorage.getItem("lang_file")
    };
  },
  created() {
    bus.$on("collapse", msg => {
      this.collapse = msg;
      bus.$emit("collapse-content", msg);
    });
  },
  computed: {
    CurrentPath() {
      const { path } = this.$route;
      this.collapse = path != '/list'? false :true //判断是否是实时数据如果是就隐藏
      let selectKey = path;
      // console.log(selectKey);
      
      // switch (selectKey) {
      //   case "/organizationalGl": //经销商
      //     this.$store.commit("pathUrl", 0);
      //     break;
      //   case "/customeruser": //客户
      //     this.$store.commit("pathUrl", 1);
      //     break;
      //   case "/region": //区域
      //     this.$store.commit("pathUrl", 2);
      //     break;
      //   case "/formList":
      //     this.$store.commit("pathUrl", 3);
      //     break;
      //   case "/passageway":
      //     this.$store.commit("pathUrl", 4);
      //     break;
      //   case "/userRights":
      //     this.$store.commit("pathUrl", 2);
      //     break;
      //       case "/parameters":
      //     this.$store.commit("pathUrl", 4);
      //     break;
      // }
      return selectKey;
    },
    ...mapState(['abckground','treeState']),
    // 根据用户权限添加更新侧边栏
    handState(){
      if(this.treeState){
        this.Postmoenu() 
      }
    },
  },
  // // 监听路由的变化
  mounted() {
    this.Postmoenu();
    //  console.log(navMenu)
    // this.moenu = navMenu;
  },
  methods: {
    activeFun(e) {
      // console.log(e)
      // this.active = e;
    },
    async Postmoenu() {
      const { code, data, mag } = await NavLeft();
      // console.log(data);
      
      this.moenu = data;
      // let { result, data } = res;
      // if (result) {
      //   this.loading = false; //关闭加载中
      //
      // } else {
      //   this.$message.error(result);
      // }
    }
  }
};
</script>
<style lang="scss">
.leftContent,
.el-menu {
  height: 100%;
}
</style>